export const shareableImages = (slug: string) =>
  `/api/shareable_images/${slug}`;
